export default __webpack_public_path__ + "static/pic02-4086501f32c3230bbbcd087c089232bc.jpeg";